import { QuizMode, QuizHandler } from "../../lib/quiz/Quiz";
import EasyButtonImage from "../../img/quizzes/EASY.png";
import NormalButtonImage from "../../img/quizzes/NORMAL.png";
import HardButtonImage from "../../img/quizzes/HARD.png";
import ExpertButtonImage from "../../img/quizzes/EXPERT.png";
import EasyGradeImage from "../../img/quizzes/grade_icons_easy.png";
import NormalGradeImage from "../../img/quizzes/grade_icons_normal.png";
import HardGradeImage from "../../img/quizzes/grade_icons_hard.png";
import ExpertGradeImage from "../../img/quizzes/grade_icons_expert.png";

interface Props {
  quizHandler: QuizHandler;
  quizMode: QuizMode;
}

export default function QuizModeButton({ quizHandler, quizMode }: Props) {
  const buttonImage = (() => {
    switch (quizMode) {
      case "easy":
        return EasyButtonImage;
      case "normal":
        return NormalButtonImage;
      case "hard":
        return HardButtonImage;
      case "expert":
        return ExpertButtonImage;
      default:
        throw new Error(`invalid quiz mode: ${quizMode}`);
    }
  })();
  const gradeImage = (() => {
    switch (quizMode) {
      case "easy":
        return EasyGradeImage;
      case "normal":
        return NormalGradeImage;
      case "hard":
        return HardGradeImage;
      case "expert":
        return ExpertGradeImage;
      default:
        throw new Error(`invalid quiz mode: ${quizMode}`);
    }
  })();
  const description = (() => {
    switch (quizMode) {
      case "easy":
        return "最近知ったアキネコさんでも大丈夫！ 初級モード";
      case "normal":
        return "アキくんのかわいさを知っているなら答えられる？！ 中級モード";
      case "hard":
        return "結構いけるかも！アキくんの配信よく見てるし？という方にオススメ 上級モード";
      case "expert":
        return "我こそはアキくんマイスター！という方にオススメ 超級モード";
      default:
        throw new Error(`invalid quiz mode: ${quizMode}`);
    }
  })();
  return (
    <div className="flex flex-col h-full p-5 bg-yellow-100 cursor-pointer group rounded-xl duration-500 ease-in-out hover:bg-yellow-300">
      <div className="duration-500 ease-in-out transform group-hover:scale-105">
        <img src={buttonImage} alt={quizMode} className="w-full" />
      </div>
      <div className="px-3 text-lg text-center text-gray-600 anzu_font">
        {description}
      </div>
      <div className="flex flex-col justify-end h-full">
        <img src={gradeImage} alt={quizMode} />
      </div>
    </div>
  );
}
